import { Box } from "@chakra-ui/react";
import { forwardRef } from "react";
import { QRCode } from 'react-qrcode-logo';

  
  const QrCodePrint = forwardRef((props: any, ref: any) => {
    const {value} = props
    return (
      <>
      <style type="text/css" media="print">
        {/* @media print{@page {size: landscape}} */}
      </style>
        <Box
          className="printDiv"
          ref={ref}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
            <QRCode eyeRadius={[30,30,30,30]} size={800} logoImage='images/logo-white.png' logoWidth={200} logoHeight={200}  fgColor='#e33621' bgColor='#fff' value={`${value}`} />
        </Box>
    </>
    );
  });
  
  export default QrCodePrint;
  